(() => {
  'use strict';
  if (customElements.get('sc-fonda-builder')) return;
  customElements.define('sc-fonda-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-fonda-data]').textContent);
      this.shoes = this.querySelector('[data-fonda-shoes]');
      this.boots = this.querySelector('[data-fonda-boots]');
      this.express = this.querySelector('[data-fonda-express]');
      this.button = this.querySelector('[data-fonda-submit]');
      this.error = this.querySelector('[data-fonda-error]');
      this.money = cents => new Intl.NumberFormat('es-CL', {style:'currency',currency:this.dataset.currency || 'CLP',maximumFractionDigits:0}).format(cents / 100);
      if (this.dataset.defaultBoots === 'true') { this.shoes.value = '0'; this.boots.value = '3'; }
      this.querySelector('form').addEventListener('input', () => this.update());
      this.querySelector('form').addEventListener('submit', event => this.submit(event));
      this.update();
    }
    selection() {
      const shoes = Number(this.shoes.value), boots = Number(this.boots.value);
      const count = shoes + boots;
      const valid = [shoes, boots].every(n => Number.isInteger(n) && n >= 0 && n <= 30) && count > 0 && count <= 30;
      if (!valid) return null;
      const prices = [...Array(shoes).fill(this.data.shoes.price), ...Array(boots).fill(this.data.boots.price)].sort((a,b) => a-b);
      const free = Math.floor(count / 3);
      const expressPrice = this.express.checked ? Number(this.data.express?.price || 0) : 0;
      const original = prices.reduce((a,b) => a+b,0) + expressPrice * count;
      const saving = prices.slice(0,free).reduce((a,b) => a+b,0) + expressPrice * free;
      const available = (!shoes || this.data.shoes.available) && (!boots || this.data.boots.available) && (!this.express.checked || this.data.express?.available);
      return {shoes,boots,count,free,original,saving,total:original-saving,available};
    }
    update() {
      const s = this.selection();
      this.querySelector('[data-fonda-detail]').textContent = s ? `${s.count} pares · ${this.express.checked ? 'Express' : 'Estándar'}` : 'Elige entre 1 y 30 pares en total.';
      this.querySelector('[data-fonda-total]').textContent = s ? this.money(s.total) : '—';
      this.querySelector('[data-fonda-original]').textContent = s?.saving ? this.money(s.original) : '';
      this.querySelector('[data-fonda-saving]').textContent = !s ? '' : s.free ? `Ahorras ${this.money(s.saving)} · ${s.free} ${s.free === 1 ? 'lavado gratis' : 'lavados gratis'}${this.express.checked ? ' + su recargo Express' : ''}` : `Agrega ${3-s.count} ${3-s.count === 1 ? 'par más' : 'pares más'} para activar el 3×2.`;
      this.button.disabled = this.busy || !s?.available;
      if (!this.busy) this.button.textContent = s ? `Agregar ${s.count} ${s.count === 1 ? 'par' : 'pares'} · ${this.money(s.total)}` : 'Agregar mis pares';
      this.error.hidden = !s || s.available;
      this.error.textContent = s && !s.available ? 'Esta selección no está disponible. Prueba otra combinación.' : '';
    }
    async submit(event) {
      event.preventDefault();
      const s = this.selection();
      if (!s?.available || this.busy) return;
      this.busy = true; this.button.disabled = true; this.button.textContent = 'Agregando…'; this.error.hidden = true;
      const items = [];
      for (const [kind, quantity] of [['shoes',s.shoes],['boots',s.boots]]) {
        if (!quantity) continue;
        const variant = this.data[kind];
        const properties = {_sc_service_group:crypto.randomUUID(),_sc_service_mode:'addon',_sc_pack:'1 Par',_sc_speed:this.express.checked ? 'Express' : 'Estándar',_sc_pairs:'1'};
        items.push({id:variant.id,quantity,properties:{...properties,_sc_service_role:'base'}});
        if (this.express.checked) items.push({id:this.data.express.id,quantity,properties:{...properties,_sc_service_role:'express-addon',_sc_base_variant:String(variant.id)}});
      }
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || 'No pudimos agregar tus pares. Inténtalo de nuevo.');
        window.location.assign(`${root}cart`);
      } catch (error) {
        this.busy = false; this.update(); this.error.textContent = error.message; this.error.hidden = false;
      }
    }
  });
})();
